/*
*
* File JS componente Top Bar
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './top-bar.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

/**
*	Funzione per nascondere la TopBar
*
*	@return {void}
*/
const topBarHide = () => {

    const topBar = document.querySelector('#top-bar');
    if(!topBar) return;

    const close = topBar.querySelector('.top-bar__close');

    close.addEventListener('click', (e) => {
        e.preventDefault()
        topBar.classList.add('hide');
    });

}


/**
*	Funzione per Animare il testo se è più grande del suo Container
*
*	@return {void}
*/

const topBarAnimateText = () => {

    const topBar = document.querySelector('#top-bar');
    const topbarContent = document.querySelector("#top-bar .top-bar__content");
    if(!topBar || !topbarContent) return;

    // per far si che c'è un "padding" di 80px
    const offsetThreshold = topBar.offsetWidth - 80;


    if ( offsetThreshold < topbarContent.offsetWidth) {
        topbarContent.classList.add("animate");
    }else{
        topbarContent.classList.remove("animate");
    }

}

const topBarInit = () => {
    //topBarHide();
    topBarAnimateText()

    window.addEventListener('resize', topBarAnimateText);
}

export default topBarInit;

//--------------------------------------------------------------------//